import { BaseModel } from '../../models/base.model';
import { ItemVariation } from './item-variation.model';

export class Item extends BaseModel {
  can_delete?: boolean;
  description: string;
  default_variation_id: number;
  disabled?: boolean;
  id: string;
  membership: boolean;
  name: string;
  unsold?: boolean;
  uuid: string;
  variations: ItemVariation[];
  sku: string;

  getDefaultVariation() {
    return this.variations.find((variation) => variation.id === this.default_variation_id);
  }

  constructor(params: any) {
    super(params);
    this.variations = (params.variations || []).map((v: any) => new ItemVariation(v));
  }
}
